module.exports = __webpack_public_path__ + "img/flechas_negras_izquierda.38c9e3ff.svg";